import type { AlertCheckedState } from '../types';

const STORAGE_KEY_PREFIX = 'alerts:actionable-checked-open-ids:';

function isValidCheckedState(value: unknown): value is AlertCheckedState {
  if (!value || typeof value !== 'object') {
    return false;
  }

  const state = value as Partial<AlertCheckedState>;
  return (
    Array.isArray(state.ids) &&
    state.ids.every(
      (id) => typeof id === 'number' && Number.isInteger(id) && id > 0,
    ) &&
    typeof state.updated_at_ms === 'number' &&
    Number.isSafeInteger(state.updated_at_ms) &&
    state.updated_at_ms > 0
  );
}

function getStorageKey(userId: number) {
  return `${STORAGE_KEY_PREFIX}${userId}`;
}

export function readAlertCheckedState(
  userId: number,
): AlertCheckedState | null {
  try {
    const rawValue = window.localStorage.getItem(getStorageKey(userId));
    if (!rawValue) {
      return null;
    }

    const value: unknown = JSON.parse(rawValue);
    return isValidCheckedState(value) ? value : null;
  } catch {
    return null;
  }
}

export function writeAlertCheckedState(
  userId: number,
  state: AlertCheckedState,
) {
  try {
    window.localStorage.setItem(getStorageKey(userId), JSON.stringify(state));
  } catch {
    // Redis remains the canonical cross-browser state when storage is blocked.
  }
}
